export const SET_POPOUT_SPINNER = 'SET_POPOUT_SPINNER';
export const CLOSE_POPOUT = 'CLOSE_POPOUT';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const PUSH_HISTORY = 'PUSH_HISTORY';
export const POP_HISTORY = 'POP_HISTORY';
export const SET_HISTORY = 'SET_HISTORY';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const SWIPE_ON = 'SWIPE_ON';
export const SWIPE_OFF = 'SWIPE_OFF';
export const SET_POPOUT = 'SET_POPOUT';
export const SET_MODAL = 'SET_MODAL';
export const SET_IS_DESKTOP = 'SET_IS_DESKTOP';
